<template>
  <div class="table-wrapper" unselectable="on">
    <LoaderWait v-show="loading"/>
    <table class="main-table">
      <tr>
        <td colspan="1" class="td-row" style="height: 200px" >
          <div class="input-head-text">
            <table style="border: 0; width: 100%; max-height: 200px;" cellpadding="0" cellspacing="0">
              <tr>
                <td rowspan="2" class="td-row">
                  <img src="/imgs/logo_impay.png">
                </td>
              </tr>
            </table>
          </div>
        </td>

        <td colspan="1" class="td-row" style="height: 200px" >
          <div class="input-head-text">
            <table style="border: 0; width: 100%; max-height: 200px;" cellpadding="0" cellspacing="0">
              <tr>
                <td rowspan="3" style="text-align: center; vertical-align: middle;" class="td-row">
                  Электронный кошелёк
                </td>
              </tr>
            </table>
          </div>
        </td>
        <td>

        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
        </td>
        <td class="td-nav" width="40%" align="center">
          <img @click="loginClick" src="/imgs/btn_impay_1.png">
        </td>
        <td class="td-nav" width="30%" align="right">
        </td>
      </tr>
      <tr>
        <td class="td-row" colspan="3" align="center">
          <table style="border: 0; width: 100%" cellpadding="8px">
            <tr v-for="(group, index) in providersPage" :key="index">
              <td width="25%" align="center">
                <div v-if="group.length > 0" @click="loginClick()" class="btn-prov">
                  <table>
                    <tr>
                      <td class="image-cell">
                        <img :src="'/imgs/op/' + group[0].img ">
                      </td>
                      <td class="text-cell">
                        <div>{{ group[0].name }}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
              <td width="25%" align="center">
                <div v-if="group.length > 1 && group[1] && group[1].img !== null" @click="loginClick()" class="btn-prov">
                  <table>
                    <tr>
                      <td class="image-cell">
                        <img v-if="group[1].img" :src="'/imgs/op/' + group[1].img ">
                      </td>
                      <td class="text-cell">
                        <div>{{ group[1].name }}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
              <td width="25%" align="center">
                <div v-if="group.length > 2 && group[2] && group[2].img !== null" @click="loginClick()" class="btn-prov">
                  <table>
                    <tr>
                      <td class="image-cell">
                        <img v-if="group[2].img" :src="'/imgs/op/' + group[2].img ">
                      </td>
                      <td class="text-cell">
                        <div>{{ group[2].name }}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
              <td width="25%" align="center">
                <div v-if="group.length > 3" @click="loginClick()" class="btn-prov">
                  <table>
                    <tr>
                      <td class="image-cell">
                        <img :src="'/imgs/op/' + group[3].img ">
                      </td>
                      <td class="text-cell">
                        <div>{{ group[3].name }}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <MessageBox :message="errorMessage" v-show="showMessage" :on-close="messageClose"></MessageBox>
    <video
        ref="promoVideo"
        class="promo-video"
        preload="auto"
        muted
        @ended="onVideoEnded"
    >
      <source src="/videos/loto.mp4?v1" type="video/mp4">
    </video>
  </div>
</template>

<script>
import LoaderWait from "@/components/LoaderWait.vue";
import MessageBox from "@/components/MessageBox.vue";
import {preloadImage} from "@/utils/preload_img";
import {preloadVideo} from "@/utils/preload_video";

export default {
  name: "StartPage",
  components: { MessageBox, LoaderWait },
  data () {
    return {
      loading: false,
      timer: null,
      timerUpdate: null,
      showMessage: false,
      errorMessage: '',
      page: 0,
      countProvs: 16,
      timeLeft: 180, // Время в секундах (3 минуты)
      timerIdentify: null,
      inactivityTimer: null,
      inactivityTimeout: 180000, // Время в милисекундах (3 минуты)
    }
  },
  computed: {
    timers() {
      return this.timer;
    },
    user() {
      const data = this.$store.getters.GET_USER_PROFILE
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
    providers () {
      const data = this.$store.getters.PROV_LIST
      if (data !== null) {
        return data;
      } else {
        return null
      }
    },
    providersPage () {
      let data = this.providers

      if (data !== null) {
        // две пустые ячейки (1й ряд по середине)
        data.splice(1, 0, {img: null})
        data.splice(1, 0, {img: null})
        const grouped = [];
        for (let i = 0; i < this.countProvs && i < data.length; i += 4) {
          const start = this.page * this.countProvs + i;
          grouped.push(data.slice(start, start + 4));
        }
        console.log(grouped);
        return grouped;
      } else {
        return null
      }
    },
    identifyState () {
      if (this.user) {
        if (this.user['identification_status'] == 2) {
          return 'Статус: На проверке ' + this.formattedTime()
        } else if (this.user['identification_status'] == 1) {
          return 'Статус: Данные подтверждены'
        }
        return 'Данные не подтверждены. Повторите регистрацию заново'
      }
      return ''
    },
    allowBack () {
      if (this.providers != null) {
        return this.page > 0
      }
      return false
    },
    allowNext () {
      if (this.providers != null) {
        return this.providers.length > (this.page + 1) * this.countProvs
      }
      return false
    }
  },
  async mounted () {
    this.updateTimer()
    await this.loadProvs();

    // for video loto
    this.resetInactivityTimer();
    window.addEventListener('mousemove', this.resetInactivityTimer);
    window.addEventListener('click', this.resetInactivityTimer);
    window.addEventListener('keydown', this.resetInactivityTimer);
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.resetInactivityTimer);
    window.removeEventListener('click', this.resetInactivityTimer);
    window.removeEventListener('keydown', this.resetInactivityTimer);
  },
  methods: {
    async loadProvs() {
      this.loading = true
      this.$store.dispatch('GET_PROV_LIST', {
      }).then(() => {
        this.loading = false

        preloadVideo('/videos/loto.mp4?v1');

        preloadImage('/imgs/key_1_1.png');
        preloadImage('/imgs/key_2_1.png');
        preloadImage('/imgs/key_3_1.png');
        preloadImage('/imgs/key_4_1.png');
        preloadImage('/imgs/key_5_1.png');
        preloadImage('/imgs/key_6_1.png');
        preloadImage('/imgs/key_7_1.png');
        preloadImage('/imgs/key_8_1.png');
        preloadImage('/imgs/key_9_1.png');
        preloadImage('/imgs/key_0_1.png');
        preloadImage('/imgs/key_0dot_1.png');
        preloadImage('/imgs/key_dot_1.png');
        preloadImage('/imgs/fwd_1.png');
        preloadImage('/imgs/back_1.png');
        preloadImage('/imgs/menu_impay_1.png');

      }).catch((e) => {
        this.loading = false
        if (e.response !== undefined && e.response.status === 401) {
          //this.$store.dispatch('AUTH_LOGOUT')
        }
      })
    },
    async updateUserInfo(isHidden = false) {
      if (!this.user) {
        return;
      }
      if (!isHidden) {
        this.loading = true
      }

      await this.$store.dispatch('AUTH_CHECK_REQUEST', {
        phone: this.user.phone,
      }).then(() => {
        this.loading = false
        if (this.user !== null && this.user['identification_status'] != 2) {
          this.stopIdentifyTimer()
        }
      }).catch((e) => {
        this.loading = false
        if (e.response !== undefined && e.response.status === 401) {
          //this.$store.dispatch('AUTH_LOGOUT')
        }
      })
    },
    updateTimer() {
      this.stopTimer()
      this.timer = setTimeout(() => this.showSessionEnd(), 60000)
      this.timerUpdate = setInterval(() => this.updateUserInfo(true), 15000)
    },
    stopTimer() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.timerUpdate !== null) {
        clearInterval(this.timerUpdate);
        this.timerUpdate = null;
      }
    },
    loginClick() {
      this.stopTimer()
      this.$router.push('login')
    },
    provClick(id) {
      if (this.user['identification_status'] != 1) {
        this.updateTimer()
        this.messageShow('Ваши данные находятся на проверке. Для оплаты услуг связи, пожалуйста, дождитесь окончания. Проверка займет не более 2х минут.')
            .then(() => this.updateUserInfo())
      } else {
        this.stopTimer()
        console.log(id)
        this.$store.dispatch('SAVE_SELECT_PROV', {
          id: id,
        }).then(() => {
          this.$router.push('input-number')
        })
      }
    },
    historyClick() {
      this.stopTimer()
      this.$router.push('history')
    },
    messageShow(message) {
      this.showMessage = true;
      this.errorMessage = message;
      // Возвращаем Promise, который будет разрешён в messageClose
      return new Promise((resolve) => {
        this.messagePromiseResolver = resolve;
      });
    },
    messageClose() {
      this.showMessage = false;
      this.errorMessage = '';
      // Разрешаем Promise, если он существует
      if (this.messagePromiseResolver) {
        this.messagePromiseResolver();
        this.messagePromiseResolver = null;
      }
    },
    backClick() {
      this.updateTimer()
      if (this.page > 0) {
        this.page--
      }
    },
    fwdClick() {
      this.updateTimer()
      if (this.providers != null) {
        this.page++
      }
    },
    backToIdentifyClick() {
      this.stopTimer()
      this.$router.replace('identify')
    },
    startIdentifyTimer() {
      if (this.timerIdentify) return; // Если таймер уже работает, не запускаем заново

      this.timerIdentify = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          clearInterval(this.timerIdentify);
          this.timerIdentify = null;
          this.onTimerIdentifyEnd();
        }
      }, 1000);
    },
    onTimerIdentifyEnd() {
      //onTimerIdentifyEnd
    },
    stopIdentifyTimer() {
      if (this.timerIdentify !== null) {
        clearInterval(this.timerIdentify);
        this.timerIdentify = null;
      }
    },
    formattedTime() {
      if (this.timerIdentify !== null) {
        const minutes = Math.floor(this.timeLeft / 60);
        const seconds = this.timeLeft % 60;
        return `(${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")})`;
      }
      return ''
    },
    showSessionEnd() {
      this.sessionTimeoutShow = true
    },
    resetInactivityTimer() {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }
      this.hidePromoVideo(); // если показано — убираем
      this.inactivityTimer = setTimeout(() => {
        this.showPromoVideo();
      }, this.inactivityTimeout);
    },

    showPromoVideo() {
      const video = this.$refs.promoVideo;
      if (video) {
        video.style.display = 'block';
        video.play().catch(err => {
          console.warn('Ошибка воспроизведения видео:', err);
        });
      }
    },

    hidePromoVideo() {
      const video = this.$refs.promoVideo;
      if (video) {
        video.pause();
        video.currentTime = 0;
        video.style.display = 'none';
      }
    },

    onVideoEnded() {
      this.hidePromoVideo();
      this.resetInactivityTimer();
    },
  }
}
</script>

<style scoped>
.btn-prov {
  display: block;
  background: url("../assets/imgs/fon_smsbilet.png") no-repeat;
  background-size: contain;
  width: 280px;
  height: 114px;
}

.btn-prov table {
  width: 100%;
  height: 114px;
  border: none;
}

.image-cell {
  vertical-align: middle;
  width: 110px;
  padding: 0 5px;
}
.image-cell img {
  width: 100%;
  max-width: 130px;
  display: block;
}
.text-cell {
  vertical-align: middle;
  font-size: 18px;
  font-weight: 500;
  max-height: 108px;
  overflow: hidden;
  padding: 4px 5px;
}
.text-cell div {
  max-height: 108px;
  word-wrap: break-word;
  text-overflow: ellipsis;
}
.promo-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: none;
  object-fit: contain;
  background-color: black;
}
</style>
